// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1gOPy","search":"Settings_search__2fSvE","filter":"Settings_filter__328IF"};